/* eslint-disable @typescript-eslint/no-explicit-any */
import { ProductStockStatus, ServiceType } from '@/constants'
import { useCart, useStore } from '@/containers'
import useCurrencyNumber from '@/hooks/useCurrencyNumber'
import type { OrderService, ProductDetail } from '@/types'
import { getTranslate } from '@/utils/api-interceptors'
import { sumBy } from 'lodash'
import { useTranslations } from 'next-intl'
import { useEffect, useMemo, type Dispatch, type SetStateAction } from 'react'

interface Props {
  entrySummaryData: ProductDetail
  setListService: Dispatch<SetStateAction<OrderService[]>>
  listService: OrderService[]
  pickUpInStore: boolean
  setPickUpInStore: Dispatch<SetStateAction<boolean>>
  priceWithService: number
  setPriceWithService: Dispatch<SetStateAction<number>>
  className?: string
}

const ProductServiceList = ({
  entrySummaryData,
  setListService,
  listService,
  setPickUpInStore,
  pickUpInStore,
  priceWithService,
  setPriceWithService,
  className,
}: Props) => {
  const { isPreOrder } = useCart()
  const t = useTranslations('ProductDetail')
  const { guestInfo } = useCart()
  const format = useCurrencyNumber()
  const { setProvinceCode } = useStore()

  const productPrice = entrySummaryData?.finalPrice
  const preOrderPrice = entrySummaryData?.preOrder?.salePrice

  const stockStatus = useMemo(() => {
    if (entrySummaryData?.stockStatus && !entrySummaryData?.flashSale) {
      if (entrySummaryData.stockStatus === ProductStockStatus.ARRIVING) {
        return ProductStockStatus.IN_STOCK
      }
      return entrySummaryData?.stockStatus
    }
    return ProductStockStatus.IN_STOCK
  }, [entrySummaryData])

  const findMinPriceItem = (items: OrderService[]) => {
    if (items.length === 0) {
      return null
    }
    let minPriceItem = items[0]
    for (let i = 1; i < items.length; i++) {
      if (items[i].price < minPriceItem.price) {
        minPriceItem = items[i]
      }
    }
    return minPriceItem
  }

  const minPriceItem = findMinPriceItem(
    listService.filter(e => e.type == ServiceType.SHIPPING_AND_INSTALL)
  )

  useEffect(() => {
    const servicePrices = sumBy(
      listService.filter(e => e.active),
      'price'
    )
    if (isPreOrder) {
      return setPriceWithService(preOrderPrice + servicePrices)
    }
    return setPriceWithService(productPrice + servicePrices)
  }, [listService])

  useEffect(() => {
    const addShippingAndInstall = listService.map(item => {
      if (minPriceItem && item._id == minPriceItem._id) {
        item.active = true
      }
      return item
    })
    setListService(addShippingAndInstall)
  }, [])

  const onChangeShippingAndInstall = (e: OrderService) => {
    const chooseShippingAndInstall = listService.map(item => {
      if (item._id == e._id) {
        item.active = true
      } else {
        if (item.type === ServiceType.SHIPPING_AND_INSTALL) {
          item.active = false
        }
      }
      return item
    })
    setPickUpInStore(false)
    setListService(chooseShippingAndInstall)
  }

  useEffect(() => {
    if (guestInfo && guestInfo.provinceCode) {
      setProvinceCode(guestInfo.provinceCode)
    }
  }, [guestInfo])

  if (
    [
      ProductStockStatus.OUT_OF_STOCK,
      ProductStockStatus.OUT_OF_BUSINESS,
    ].includes(stockStatus as ProductStockStatus)
  )
    return null

  return (
    <>
      {listService && listService.length > 0 && (
        <div
          className={`priceNotLogin text-black overflow-hidden rounded-xl border border-[#D1D5DB] text-sm ${className}`}
        >
          <h2 className='bg-[#F3F4F6] px-2 py-4 font-semibold'>
            Dịch vụ mở rộng
          </h2>
          <div className='flex flex-col gap-3 bg-white px-2 py-3'>
            {listService
              ?.filter(e => e.type == ServiceType.SHIPPING_AND_INSTALL)
              .map((e, i) => (
                <div
                  className='form-check-default form-check-shipping box-checkbox'
                  key={i}
                >
                  <input
                    className='form-checkbox-input'
                    id={e?._id}
                    type='radio'
                    defaultChecked={minPriceItem?._id === e?._id}
                    name={ServiceType.SHIPPING_AND_INSTALL}
                    onClick={() => onChangeShippingAndInstall(e)}
                  />
                  <label
                    className='form-checkbox-label flex flex-col'
                    htmlFor={e?._id}
                  >
                    <div className='w-full gap-x-2 leading-5'>
                      <span>{getTranslate(e.name)}</span>
                    </div>
                    {getTranslate(e?.description) && (
                      <p className='italic leading-4'>
                        ({getTranslate(e.description)})
                      </p>
                    )}
                  </label>
                </div>
              ))}

            {(listService?.filter(e => e.active).length > 0 ||
              pickUpInStore) && (
              <div className='tempCalculate mt-2 border-t border-zinc-300 pb-2 pt-[10px]'>
                <span className='font-bold'>{t('priceWithService')}:</span>
                <span className='ml-1 text-fieldInput font-bold text-price'>
                  {format(priceWithService)}
                </span>
              </div>
            )}
          </div>
        </div>
      )}
    </>
  )
}

export default ProductServiceList
